import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  BusinessProfileState,
  BusinessProfileGeneralState,
  BusinessProps,
  UpdateBusinessLogoProps,
  UpdateBusinessProfileProps,
  UpdateAdressBusinessProfileProps,
  UpdateFacebookConfigProps,
  updateConfigurationProps,
  configurationState,
} from "./types";
import ApiService from "services/ApiService";

export const getBusinessProfile = createAsyncThunk(
   'business/getBusinessProfile',
   async ({ id, token }: BusinessProps) => {
      try {
         const config = {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         };
         const response = await ApiService.get(
            `${process.env.REACT_APP_API_URL}/api/v1/business/${id}`,
            config
         );

         if (response && response.data) {
            console.log('response2', response.data);
            return {
               data: response.data,
               status: 'success',
               error: null,
            } as unknown as BusinessProfileState;
         } else {
            return {
               data: response.data?.message,
               status: 'empty',
               error: null,
            } as unknown as BusinessProfileState;
         }
      } catch (err) {
         if (err)
            return {
               data: 'Something went wrong!',
               status: 'error',
               error: err,
            } as unknown as BusinessProfileState;
      }
   }
);

export const updateBusinessProfile = createAsyncThunk(
   'profile/updateBusinessProfile',
   async (data: UpdateBusinessProfileProps) => {
      try {
         console.log('🔧 updateBusinessProfile called with:', data);
         console.log('📦 FormData contents:');

         const config = {
            headers: {
               Authorization: `Bearer ${data.token}`,
            },
         };
         
         console.log('🚀 Making API call to:', `${process.env.REACT_APP_API_URL}/api/v1/business/${data.id}`);

         
         const response = await ApiService.post(
            `${process.env.REACT_APP_API_URL}/api/v1/business/${data.id}`,
            data.data,
            config
         );

         console.log('✅ updateBusinessProfile API Response:', response);

         if (response && response.data) {
            return {
               data: response.data,
               status: 'success',
               error: null,
            } as unknown as BusinessProfileGeneralState;
         } else {
            return {
               data: response.data?.message,
               status: 'empty',
               error: null,
            } as unknown as BusinessProfileGeneralState;
         }
      } catch (err) {
         console.error('💥 updateBusinessProfile error:', err);
         if (err)
            return {
               data: 'Something went wrong!',
               status: 'error',
               error: err,
            } as unknown as BusinessProfileGeneralState;
      }
   }
);

export const updateAddressBusinessProfile = createAsyncThunk(
   'profile/updateAddressBusinessProfile',
   async ({
      id,
      address,
      areaId,
      lng,
      lat,
      suburbId,
      token,
      provinceId,
      cityId,
   }: UpdateAdressBusinessProfileProps) => {
      try {
         const config = {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         };
         const response = await ApiService.post(
            `${process.env.REACT_APP_API_URL}/api/v1/business/address/${id}`,
            {
               address,
               areaId,
               lng,
               lat,
               suburbId,
               provinceId,
               cityId,
            },
            config
         );
         if (response && response.data) {
            return {
               data: response.data,
               status: 'success',
               error: null,
            } as unknown as BusinessProfileGeneralState;
         } else {
            return {
               data: response.data?.message,
               status: 'empty',
               error: null,
            } as unknown as BusinessProfileGeneralState;
         }
      } catch (err) {
         if (err)
            return {
               data: 'Something went wrong!',
               status: 'error',
               error: err,
            } as unknown as BusinessProfileGeneralState;
      }
   }
);

export const updateBusinessLogo = createAsyncThunk(
  'profile/updateBusinessLogo',
  async ({ id, foto, icon, token }: UpdateBusinessLogoProps) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await ApiService.post(
        `${process.env.REACT_APP_API_URL}/api/v1/business/update-media/${id}`,
        {
          foto,
          icon,
        },
        config
      );

      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as BusinessProfileState;
      } else {
        return {
          data: response.data?.message,
          status: "empty",
          error: null,
        } as unknown as BusinessProfileState;
      }
    } catch (err) {
      if (err)
        return {
          data: "Something went wrong!",
          status: "error",
          error: err,
        } as unknown as BusinessProfileState;
    }
  }
);
export const updateFacebookConfig = createAsyncThunk(
   "facebook-config/update",
   async (data: UpdateFacebookConfigProps) => {
     try {
       const config = {
         headers: {
           Authorization: `Bearer ${data.token}`,
         },
       };
       const response = await ApiService.post(
         `${process.env.REACT_APP_API_URL}/api/v1/business/facebook-config/${data.id}`,
         data.data,
         config
       );
 
       if (response && response.data) {
         return {
           data: response.data,
           status: "success",
           error: null,
         } as unknown as BusinessProfileState;
       } else {
         return {
           data: response.data?.message,
           status: "empty",
           error: null,
         } as unknown as BusinessProfileState;
       }
     } catch (err) {
       if (err)
         return {
           data: "Something went wrong!",
           status: "error",
           error: err,
         } as unknown as BusinessProfileState;
     }
   }
 );


 export const updateConfiguration = createAsyncThunk(
  'profile/updateConfiguration',
  async ({ id, configurationData, token }: updateConfigurationProps) => {
    try {
      const payload = { configurationData };

      console.log('🔧 updateConfiguration called with payload:', { id, payload, token });

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      };

      const response = await ApiService.post(
        `${process.env.REACT_APP_API_URL}/api/v1/business/update-configuration/${id}`,
        payload,
        config
      );

      console.log('✅ updateConfiguration API Response:', response);

      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as configurationState;
      } else {
        return {
          data: response.data?.message,
          status: "empty",
          error: null,
        } as  unknown as configurationState;
      }
    } catch (err) {
      console.error('❌ Error in updateConfiguration:', err);
      return {
        data: "Something went wrong!",
        status: "error",
        error: err,
      }  as unknown as configurationState;
    }
  }
);


//  export const updateConfiguration = createAsyncThunk(
//   'profile/updateConfiguration',
//   async ({ id, ConfigurationData, token }: updateConfigurationProps) => {
//     try {
//       console.log('🔧 updateConfiguration called with payload:', { id, ConfigurationData, token });
//       const config = {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       };
//       const response = await ApiService.post(
//         `${process.env.REACT_APP_API_URL}/api/v1/business/update-configuration/${id}`,
//         ConfigurationData,
//         config
//       );

//        console.log('✅ updateConfiguration API Response:', response);

//       if (response && response.data) {
//         return {
//           data: response.data,
//           status: "success",
//           error: null,
//         } as unknown as configurationState;
//       } else {
//         return {
//           data: response.data?.message,
//           status: "empty",
//           error: null,
//         } as unknown as configurationState;
//       }
//     } catch (err) {
//       if (err)
//         return {
//           data: "Something went wrong!",
//           status: "error",
//           error: err,
//         } as unknown as configurationState;
//     }
//   }
// );